import { MarketingDescriptionProps } from '../types';

export const MarketingDescription = ({
  children
}: MarketingDescriptionProps) => {
  return <div className="p-4 mx-md-3 my-md-2">{children}</div>;
};
